import * as React from 'react';

import { createGlobalStyle } from 'styled-components';

import * as Styled from './global-styles.styled';

const GlobalStyles = createGlobalStyle`
  ${Styled.Reset}
`;

export default React.memo(GlobalStyles);
